




















import { defineComponent } from "@vue/composition-api";
import { PostFileData } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import PostFilePreview from "../../../PostFilePreview";
import PublicAccessToggle from "../../../PublicAccessToggle";

export default defineComponent({
  name: "DraggableFilePreview",
  components: { BaseIcon, PublicAccessToggle, PostFilePreview },
  props: {
    postFile: { type: Object as () => PostFileData, required: true },
    showPublicAccessToggle: { type: Boolean, default: false },
    draggableClass: { type: String, default: "" },
  },
});
